var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card-header",staticStyle:{"text-align":"-webkit-center"}},[_c('font-awesome-icon',{attrs:{"icon":"inbox"}}),_vm._v(" "+_vm._s(_vm.$t('Storage Location Info'))+" ")],1),_c('StorageInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }